<template>
    <div class="search_bar_desktop leaderboardview">
    <div class="input-group search_map_desktop">
      <span class="input-group-addon map_addon_desktop" id="search-addon-map-desktop"><i class="icon-race"></i></span>
      <select v-on:change="change" class="form-control" id="categoriesSelect">
        <option
                v-for="race in trackingRaces"
                :selected="race.id === selectedRaceId"
                v-bind:value="race.id"
        >{{ race.name }}</option>
      </select>
    </div>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  data: function () {
    return {
      selectedRace: null
    }
  },
  computed: {
    ...mapGetters({
      event: 'event',
      races: 'races',
      mobile: 'mobile',
      selectedRaceId: 'raceId'
    }),
    trackingRaces() {
      if(this.event.races && this.event.races.length > 0) {
        return this.event.races.filter((race) => {
          return race.tracking_type !== null
        })
      }
      return []
    }
  },
  methods: {
      change(event) {
          let raceId = event.target.value
          this.$store.dispatch('loadRace', raceId)
          this.$ma.trackEvent({category: 'Click', action: 'Toggle race header', label: 'Loaded', value: ''})
          if (this.mobile) {
              // this.$router.push({name: 'map', params: {raceId: raceId}})
          } else {
              this.$router.push({name: 'leaderboard', params: {raceId: raceId}})
          }
      }
  }
  // watch: {
  //   selectedCat: function () {
  //     this.$store.dispatch('loadSelectedCat', this.selectedCat)
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/races.vue